export default __webpack_public_path__ + "static/media/img-no-products.22b45a83.png";